import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Label,
} from "recharts";

// project import
import MainCard from "components/MainCard";
import Dot from "components/@extended/Dot";
import {
  IMemberStatusChartResult,
  IMemberTotalCountResult,
} from "../../api/types";
import CircularProgress from "@mui/material/CircularProgress";
import { Divider } from "antd";

// ==============================|| MemberStatus - PIE CHART ||============================== //

type Props = {
  totalcount?: IMemberTotalCountResult;
  data?: IMemberStatusChartResult | null;
  isFetching: boolean;
};

const MemberStatusPieChart = ({ totalcount, data, isFetching }: Props) => {
  if (isFetching) {
    return (
      <MainCard title="Total Members">
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ height: "100%" }}
        >
          <CircularProgress />
        </Grid>
      </MainCard>
    );
  }

  if (!data) {
    return (
      <Typography variant="h6" color="error">
        No Data Found!
      </Typography>
    );
  }

  const COLORS = ["#FFBB28", "#00C49F", "#eb3434"];

  const pieData = [
    { name: "Pending Members", value: data.pending_Members },
    { name: "Approved Members", value: data.approved_Members },
    { name: "Rejected Members", value: data.rejected_Members },
  ];

  const DotSize = { display: "flex", alignItems: "center", gap: 1 };

  return (
    <MainCard
      darkTitle
      title="Total Members"
    >
      <Grid container alignItems="center" justifyContent="center" spacing={1}>
        <Grid item xs={12} md={12} container justifyContent="center">
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie
                data={pieData}
                innerRadius={60}
                outerRadius={100}
                fill="#8884d8"
                paddingAngle={2}
                dataKey="value"
              >
               {pieData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
                <Label
                  value="Total"
                  position="center"
                  fontSize="14"
                  fontWeight="bold"
                  fill="#333"
                />
                <Label
                  value={totalcount?.totalMember}
                  position="center"
                  fontSize="18"
                  fontWeight="bold"
                  fill="#333"
                  dy={20}
                />
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Divider dashed />
            <Grid item xs sx={DotSize}>
              <Dot sx={{ backgroundColor: "#FFBB28" }} size={12} />
              <Typography variant="subtitle1" color="text.secondary">
                Pending
              </Typography>
            </Grid>
            <Grid item xs sx={DotSize}>
              <Dot sx={{ backgroundColor: "#00C49F" }} size={12} />
              <Typography variant="subtitle1" color="text.secondary">
                Approved
              </Typography>
            </Grid>
            <Grid item xs sx={DotSize}>
              <Dot sx={{ backgroundColor: "#eb3434" }} size={12} />
              <Typography variant="subtitle1" color="text.secondary">
                Rejected
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default MemberStatusPieChart;
